import React from "react";

const CPCSection = ({ formData, setFormData }) => {
  const cpcOptions = ["CPC1", "CPC2", "CPC3", "CPC4", "CPC5", "기록예정"];
  const cpcDescriptions = [
    "CPC1 - 의식있으며, 명료하고 노동(일)을 할 수 있고, 경미한 신경학적, 정신학적 결손이 있을 수 있다.",
    "CPC2 - 의식있으며, 독립적인 일상생활 활동을 하기에 충분한 뇌기능, 주거환경에서 노동(일)을 할 수 있다.",
    "CPC3 - 손상된 뇌기능 때문에 매일 도움을 위해 다른 사람에 의존한다. 보행가능부터 심각한 치매 또는 마비까지 범주가 다양하다.",
    "CPC4 - 혼수(coma) 이지만 brain death는 아닌 경우. 환경과 상호작용 없으며 의식 없음, 자발적으로 눈뜸과 수면/기상 주기가 있을 수 있다. 대뇌 반응 없음.",
    "CPC5 - 무호흡, 무반사, EEG silence",
  ];

  const cpcFields = [
    { id: "Discarge_CPC", label: "Discarge_CPC" },
    { id: "1month_CPC", label: "1month_CPC" },
    { id: "3month_CPC", label: "3month_CPC" },
    { id: "6month_CPC", label: "6month_CPC" },
    { id: "12month_CPC", label: "12month_CPC" },
  ];

  return (
    <section className="form-section">
      <h3>4-3. CPC</h3>

      {/* CPC 평가 필드들 */}
      {cpcFields.map((field) => (
        <div key={field.id} className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">{field.label}</label>
            <div className="input_1col">
              {cpcOptions.map((option) => (
                <label key={`${field.id}-${option}`} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name={field.id}
                    value={option}
                    checked={formData[field.id] === option}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        [field.id]: e.target.value,
                      })
                    }
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      ))}

      {/* CPC 설명 */}
      <ul>
        {cpcDescriptions.map((desc, index) => (
          <li key={index}>{desc}</li>
        ))}
      </ul>

      <h3> 영상 업로드</h3>
      {/* 의료 이미지 섹션 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">Chest X-ray 종류</label>
          <div className="input_1col">
            {["PA", "AP", "none"].map((option) => (
              <label key={option} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="chest_image"
                  value={option}
                  checked={formData.chest_image === option}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      chest_image: e.target.value,
                    })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{option}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 파일 업로드 필드들 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">Choose File Chest X-ray</label>
          <input
            type="file"
            name="file_chest"
            className="form-control"
            onChange={(e) =>
              setFormData({
                ...formData,
                file_chest: e.target.files[0],
              })
            }
          />
        </div>
      </div>

      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">Choose File EKG</label>
          <input
            type="file"
            name="file_EKG"
            className="form-control"
            onChange={(e) =>
              setFormData({
                ...formData,
                file_EKG: e.target.files[0],
              })
            }
          />
        </div>
      </div>
    </section>
  );
};

export default CPCSection;
